var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPayment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.439 0.231L6.731 0.231 6.731 6.527 0.439 6.527z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0 0.506L32.134 0.506 32.134 14.667 0 14.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(0 .75)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .75) translate(8 12.667) translate(22 .436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EFB726",
    d: "M6.73 3.377c0 1.739-1.407 3.15-3.144 3.15C1.85 6.527.44 5.116.44 3.377.439 1.64 1.85.231 3.586.231c1.737 0 3.145 1.408 3.145 3.146",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .75) translate(8 12.667) translate(0 7.77)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M27.899 13.186c-.285 0-.552-.11-.754-.312-.416-.416-.416-1.092 0-1.508l2.782-2.782-2.782-2.78c-.202-.203-.314-.47-.314-.756 0-.284.112-.552.314-.753.201-.203.468-.314.754-.314.285 0 .552.111.754.314l2.91 2.909c.368.368.571.858.571 1.38 0 .522-.203 1.012-.572 1.38l-2.91 2.91c-.201.201-.469.312-.753.312M6.98 2.64c-2.682.053-4.847 2.252-4.847 4.947 0 2.693 2.164 4.89 4.845 4.944-1.304-1.333-2.02-3.082-2.02-4.944 0-1.863.717-3.614 2.022-4.947m5.028 0c-.622.003-1.228.122-1.804.354-.106.078-.238.137-.379.168-1.68.841-2.732 2.538-2.732 4.425s1.053 3.583 2.748 4.428c.126.027.257.085.375.17.56.223 1.167.343 1.791.347-1.304-1.332-2.02-3.082-2.02-4.945 0-1.863.717-3.615 2.021-4.948m5.058 0c-2.728 0-4.947 2.22-4.947 4.948 0 2.726 2.22 4.945 4.947 4.945 2.728 0 4.948-2.219 4.948-4.945 0-2.728-2.22-4.948-4.948-4.948m0 12.028c-.87 0-1.724-.16-2.536-.473-.764.313-1.618.473-2.49.473-.858 0-1.7-.155-2.504-.46-.754.305-1.596.46-2.458.46C3.176 14.667 0 11.49 0 7.587 0 3.682 3.176.506 7.08.506c.86 0 1.701.153 2.504.458C10.34.66 11.183.506 12.04.506c.873 0 1.727.158 2.54.472.764-.314 1.617-.472 2.487-.472 3.903 0 7.08 3.176 7.08 7.081 0 3.903-3.177 7.08-7.08 7.08",
    mask: "url(#prefix__d)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_payment.fa4ce9ee744bc417d3c4134f676799ed.svg";